module.exports = __webpack_public_path__ + "img/meng.1f45fa8f.png";